import { Component, OnInit, Output, EventEmitter, ElementRef, AfterViewInit, ViewRef } from '@angular/core';
import { GameService } from '../../services/game.service';
import { AudioPlayerService } from '../../services/audio-player.service';
import { environment } from '../../../environments/environment';

const levelMap = [
  'dobbelsteen', 'plant', 'blokken', 'ketting', 'knikkers', 'koptelefoon', 'rolstoel', 'foto'
]

@Component({
  selector: 'app-img-open-baggage',
  templateUrl: './img-open-baggage.component.html',
  styleUrls: ['./img-open-baggage.component.less']
})
export class ImgOpenBaggageComponent implements OnInit, AfterViewInit {
  @Output() onCloseClick = new EventEmitter<any>();
  @Output() onLevelClick = new EventEmitter<any>();

  constructor(
    private hostElement: ElementRef<SVGAElement>,
    private gameService: GameService,
    public audio: AudioPlayerService
  ) { }

  ngAfterViewInit(): void {
    switch (environment.version) {
      case 'broedels': return this.initBroedels();
    }
  }

  ngOnInit() {
    switch (environment.version) {
      case 'jijenik': return this.initJijenik();
    }
  }

  private initJijenik() {
    document.querySelectorAll('.item').forEach(i => {
      i.classList.add('hidden');
    })

    for (let i of this.gameService.getActiveLevels()) {
      document.querySelector('#' + this.getLevelName(i))?.classList.remove('hidden');
    }
  }
  private initBroedels() {
    this.hostElement.nativeElement.querySelector('.btnBack')?.addEventListener('click', this.closeClick.bind(this));
    const activeLevels = this.gameService.getActiveLevels();

    levelMap.forEach((levelName, index) => {
      const levelButton = this.hostElement.nativeElement.querySelector('#' + levelName);
      if (levelButton) {
        const button = levelButton as SVGGElement;
        button.classList.add('levelButton')
        button.addEventListener('click', (e) => { this.levelIdClick(index + 1) })
        if (activeLevels.find(al => al === (index +1))) {
          button.classList.add('enabled');
        }
      }

    })
  }

  closeClick() {
    this.onCloseClick.emit(null);
  }

  levelIdClick(levelId: number) {
    this.onLevelClick.emit(levelId);
  }

  levelClick(levelName: string) {
    this.onLevelClick.emit(this.getLevelId(levelName));
  }

  getLevelName(id: number) {
    if (environment.version === 'jijenik') {
        switch (id) {
          case 8: return 'kado';
          case 1: return 'foto';
          case 7: return 'metrokaart';
          case 6: return 'reisgids';
          case 5: return 'koptelefoon';
          case 4: return 'ticket';
          case 3: return 'buskaart';
          case 2: return 'geld';
        }
    } else {

    }

  }
  getLevelId(name: string): number {
    switch (name) {
      case 'kado': return 8;
      case 'foto': return 1;
      case 'metrokaart': return 7;
      case 'reisgids': return 6;
      case 'koptelefoon': return 5;
      case 'ticket': return 4;
      case 'buskaart': return 3;
      case 'geld': return 2;
      default:
        throw Error('invalid level name');
    }
  }
}
